import React, { Component } from "react";
import TrainingMyStoreCheckout from "./stripe/TrainingMyStoreCheckout";
import $ from "jquery";

class BuyTraining extends Component {
  componentDidMount() {
    $(".modal-backdrop").removeClass("show").addClass("hide");
  }

  render() {
    return (
      <React.Fragment>
        <section className="position-relative top-100">
          <div className="row d-flex">
            <div className="col-lg-6 col-md-8 m-auto">
              <TrainingMyStoreCheckout />
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default BuyTraining;